import React from "react";
import "./TestInRoom.css";
//import 'aframe';
import registerClickDrag from 'aframe-click-drag-component';
registerClickDrag(window.AFRAME);

/*
function new_script(src) {
    return new Promise(function(resolve, reject){
      var script = document.createElement('script');
      script.src = src;
      script.addEventListener('load', function () {
        resolve();
      });
      script.addEventListener('error', function (e) {
        reject(e);
      });
      document.head.insertAdjacentElement("beforeend", script);
      //document.body.appendChild(script);
    })
  }; */
  // Promise Interface can ensure load the script only once.
  //var my_script = new_script("https://raw.githack.com/jeromeetienne/AR.js/2.0.5/aframe/build/aframe-ar.js");


class TestInRoom extends React.Component {
    constructor(props){
        super(props);
        this.state ={
            status: 'start'
        };

        
    }

    componentDidMount () {
        
        // just some random code to try out Aframe and Three js APIs
        var sceneEl = document.querySelector('a-scene');
        var entityEl = document.createElement('a-entity');
        entityEl.setAttribute("geometry", "primitive: box; width: 1; height: 1; depth: 1");
        entityEl.setAttribute('position', "-1, 1.25, -5")
        entityEl.setAttribute('id', "additionalBox")
        entityEl.setAttribute('scale', '1 1 1')
        entityEl.setAttribute('material', 'color:blue;transparent:true; opacity:0.8')
        entityEl.setAttribute("click-drag", null);
        sceneEl.appendChild(entityEl);
    
        var geometry = new window.THREE.BoxGeometry();
        var material = new window.THREE.MeshBasicMaterial( { color: 0x00ff00 } );
        var cube = new window.THREE.Mesh( geometry, material );
    
        var scene = document.querySelector('a-scene').object3D;
        scene.add(cube);
    
        var entities = document.querySelectorAll('a-entity');
        var lastEntity = entities[entities.length-1];
        lastEntity.setAttribute('click-drag', null);
        console.log("current length", entities.length);
    }

    /*
    do_load = () => {
        var self = this;
        my_script.then(function() {
          self.setState({'status': 'done'});
        }).catch(function() {
          self.setState({'status': 'error'});
        })
    }*/

    render(){
        /*
        var self = this;
        if (self.state.status === 'start') {
          self.state.status = 'loading';
          setTimeout(function () {
            self.do_load()
          }, 0);
        }*/

        return (
            <div>
                <a-scene>

                 <a-sphere  click-drag position="0 1.25 -5" radius="1.25" color="#EF2D5E"></a-sphere>

                 
                 <a-entity position="0 0 10">
                   <a-camera look-controls="enabled:false" ></a-camera>
                </a-entity>

                </a-scene>
            </div>
        )       
    }
}

export default TestInRoom; 